
  import { createApiClient } from 'Network/ApiClient';
  
  export const InsuranceAxiosInstance = createApiClient('InsurancePlan/');


